var exports = {
  "dK": "MessageComponents.module__components___LVNMbl",
  "nM": "MessageComponents.module__row___LVNMbl",
  "x6": "MessageComponents.module__button___LVNMbl",
  "kX": "MessageComponents.module__success___LVNMbl",
  "Zg": "MessageComponents.module__emoji___LVNMbl",
  "Pf": "MessageComponents.module__label___LVNMbl",
  "Qs": "MessageComponents.module__content___LVNMbl",
};

module.exports = exports;
